import { gql, useMutation } from '@apollo/client';

export const CREATE_SINGLE_DATEV_FILE = gql`
  mutation createSingleDatevExportFile($payload: CreateSingleDatevExportInput!) {
    createSingleDatevExportFile(payload: $payload) {
      _id
      location
    }
  }
`;

export const useCreateSingleDatevExportFile = () => {
  const [createSingleDatevExportFile, { loading }] = useMutation(CREATE_SINGLE_DATEV_FILE);
  return { createSingleDatevExportFile, loading };
};
